import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import State from '@wfp-root-app/store/state';

import { ManagerPermission } from '../../permission-profiles/permission';
import { ActivityLogsList } from '../../activityLogs/ActivityLogsList';
import { PagedState } from '../../utils/paging';
import { useManagerParams } from '../hooks/useManagerParams';
import { SORT_OPTIONS } from '../../utils/hooks/useSort';
import { getManagerActivityLogs } from '../../apiClient';
import { ActionCreators as ManagerActionCreators } from '../managers';
import { ActionCreators as PartnerActionCreators } from '../../partners/partnersActions';

export const ActivityLogs: FC = () => {
    const {
        auth,
        partners,
        managers: { managerNickNameList },
    } = useSelector((state: State) => state);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [activityLogs, setActivityLogs] = useState(new PagedState<any>());
    const managerParams = useManagerParams();
    const dispatch = useDispatch();

    const loadActivityLogs = (page: number, limit: number, managerId?: string) => {
        return getManagerActivityLogs(managerId, page, limit).then((result) => {
            setActivityLogs(result);
        });
    };

    const loadManagersNickNames = () => {
        const actionRef = ManagerActionCreators.loadManagersNickNames();
        actionRef(dispatch);
    };

    const loadPartnersNames = (sortOptions: SORT_OPTIONS) => {
        const actionRef = PartnerActionCreators.loadPartnersNames(sortOptions);
        actionRef(dispatch);
    };

    const loadPartnerUserNames = (sortOptions: SORT_OPTIONS) => {
        const actionRef = PartnerActionCreators.loadPartnerUsersName(sortOptions);
        actionRef(dispatch);
    };

    const renderActivityLogs = () => {
        return (
            <div>
                <ActivityLogsList
                    activityLogs={activityLogs}
                    auth={auth}
                    downloadRestriction={[ManagerPermission.userActivityDownload]}
                    entityId={managerParams.manager.id}
                    isManager={true}
                    loadActivityLogs={loadActivityLogs}
                    loadManagersNickNames={loadManagersNickNames}
                    loadPartnerUserNames={loadPartnerUserNames}
                    loadPartnersNames={loadPartnersNames}
                    managersNickNames={managerNickNameList}
                    partnerUsersNickNames={partners.partnerUsersNamesList}
                    partnersNickNames={partners.nameList}
                    url={`/admin/${managerParams.manager.id}/activity/export-activity-log`}
                />
            </div>
        );
    };

    return auth.manager ? renderActivityLogs() : <>loading</>;
};
